import React from 'react'
import Profile from './profile'

const About = () => {

    const profile = {

        profileImage: 'assets/images/masoud-codes.gif',
    
        background: 'assets/images/cc-bg-1.jpg',
    
        fullName: 'Sharifu .H. Masudi',
    
        age: new Date().getFullYear() - 1997,
    
        email: 'sharifumasudi66@gmail.com',
    
        phone: '+255622183130',
    
        altenateImage: "image profile",
    
        addres: 'P.O.BOX 3000, Morogoro Tanzania',
    
        language: 'English, Swahili',
    
        aboutTitle: 'Web Developer, System developer Graphic Designer,  Mobile App developer',
    
        aboutDetails: `
        Innovative tech professional with 3+ years of experience working as a computer programmer. Capable of working with a
        variety of technology and software solutions and managing databases. Valuable team member who has experience
        diagnosing problems and developing solutions. Extensive expertise in networking systems and working with mainframe
        computers. Talented leader with unique ideas and a history of successful contributions in the field.
        `
      }
  return (
    <>
        <Profile/>
        <div className="section" id="about">
            <div className="container">
                <div className="card" data-aos="fade-up" data-aos-offset="10">
                <div className="row">
                    <div className="col-lg-6 col-md-12">
                    <div className="card-body">
                        <div className="h4 mt-0 title">About</div>
                        <p className='text-justify'>Hello! I am {profile.fullName}. {profile.aboutTitle}.</p>
                        <p>{profile.aboutDetails}</p>
                    </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                    <div className="card-body">
                        <div className="h4 mt-0 title">Basic Information</div>
                        <div className="row">
                        <div className="col-sm-4"><strong className="text-uppercase">Age:</strong></div>
                        <div className="col-sm-8">{profile.age}yrs</div>
                        </div>
                        <div className="row mt-3">
                        <div className="col-sm-4"><strong className="text-uppercase">Email:</strong></div>
                        <div className="col-sm-8">{profile.email}</div>
                        </div>
                        <div className="row mt-3">
                        <div className="col-sm-4"><strong className="text-uppercase">Phone:</strong></div>
                        <div className="col-sm-8">{profile.phone}</div>
                        </div>
                        <div className="row mt-3">
                        <div className="col-sm-4"><strong className="text-uppercase">Address:</strong></div>
                        <div className="col-sm-8">{profile.addres}</div>
                        </div>
                        <div className="row mt-3">
                        <div className="col-sm-4"><strong className="text-uppercase">Language:</strong></div>
                        <div className="col-sm-8">{profile.language}</div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>

    </>
  )
}

export default About
